import { FC, useState } from 'react';

import { Box, Fade } from '@mui/material';

import ShoppingCartContentLists from './ShoppingCartContentLists';
import ShoppingCartMediaPlanPicker from './ShoppingCartMediaPlanPicker';
import ShoppingCartNewMediaPlanForm from './ShoppingCartNewMediaPlanForm';

const ShoppingCartContent: FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <>
      <Box sx={{ display: activeStep === 2 ? 'block' : 'none', padding: '0!important' }}>
        <Fade in={activeStep === 2} timeout={200}>
          <ShoppingCartNewMediaPlanForm handleClose={handleClose} setActiveStep={setActiveStep} />
        </Fade>
      </Box>

      <Box sx={{ display: activeStep === 1 ? 'block' : 'none', padding: '0!important' }}>
        <Fade in={activeStep === 1} timeout={200}>
          <ShoppingCartMediaPlanPicker handleClose={handleClose} setActiveStep={setActiveStep} />
        </Fade>
      </Box>

      <Box sx={{ display: activeStep === 0 ? 'block' : 'none', padding: '0!important' }}>
        <Fade in={activeStep === 0} timeout={200}>
          <ShoppingCartContentLists handleClose={handleClose} setActiveStep={setActiveStep} />
        </Fade>
      </Box>
    </>
  );
};

export default ShoppingCartContent;
